import { render, staticRenderFns } from "./RootContainer.vue?vue&type=template&id=cdf1a99c&scoped=true&"
import script from "./RootContainer.vue?vue&type=script&lang=js&"
export * from "./RootContainer.vue?vue&type=script&lang=js&"
import style0 from "./RootContainer.vue?vue&type=style&index=0&id=cdf1a99c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf1a99c",
  null
  
)

export default component.exports